import { TitleFull as Title, TitleLightWithSelectedParent } from '@warehouse/title/core';
import { TitleIndexedPartOfCompilation } from '@warehouse/graphql';
import { ChildrenColumnType } from '../children-compilation-extended.model';

/**
 * @deprecated Please define it properly in the Compilation object mother.
 * We want to avoid magic like this.
 */
export function mapEntryClassAndEntryNumberToData(
	data: TitleLightWithSelectedParent[],
	compilation: Title,
): ChildrenColumnType[] {
	const compilationEntries = compilation?.metadata?.coreMetadata?.compilationObject?.compilationEntries;
	return data.map((child) => {
		const compilationObjectEntry = getCompilationObjectEntry(child, compilation.uuid);
		const compilationEntry = compilationEntries?.find((entry) => entry.contentId === child.uuid);

		return {
			...child,
			entryClass: compilationObjectEntry?.compilationEntryClass?.label,
			entryNumber: compilationObjectEntry?.compilationEntryNumber,
			selectedParent: {
				...child.selectedParent,
				primary: compilationEntry?.primary === true,
			},
		};
	});
}

function getCompilationObjectEntry(
	child: TitleLightWithSelectedParent,
	compilationUuid: string,
): TitleIndexedPartOfCompilation | undefined {
	return child.partOfCompilations?.find((compilation) => compilation.compilationId === compilationUuid);
}
